// Security: XSS prevention utilities for template rendering

export function escapeHtml(str: string): string {
  if (!str || typeof str !== 'string') return '';
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function escapeAttr(str: string): string {
  if (!str || typeof str !== 'string') return '';
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function sanitizeText(str: string): string {
  if (!str || typeof str !== 'string') return '';
  let clean = str.replace(/<[^>]*>/g, '');
  clean = clean.replace(/javascript:/gi, '');
  clean = clean.replace(/data:/gi, '');
  clean = clean.replace(/vbscript:/gi, '');
  clean = clean.replace(/on\w+\s*=/gi, '');
  return escapeHtml(clean);
}

export function sanitizeSeoText(str: string, maxLength: number): string {
  if (!str || typeof str !== 'string') return '';
  let clean = str.replace(/<[^>]*>/g, '');
  clean = clean.replace(/[\r\n\t]/g, ' ');
  clean = clean.replace(/javascript:/gi, '');
  clean = clean.replace(/data:/gi, '');
  clean = clean.replace(/vbscript:/gi, '');
  clean = clean.replace(/on\w+\s*=/gi, '');
  clean = clean.substring(0, maxLength);
  return escapeAttr(clean);
}
